import type React from 'react'
import { cn } from '@/frontend/utils'

export function H3({ className, ...props }: React.ComponentPropsWithoutRef<'h3'>) {
  return (
    <h3
      {...props}
      className={cn('font-semibold text-contentPrimary text-lg leading-6', className)}
    />
  )
}
